import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle } from "react-native-svg";

export const IconReduceMotion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconReduceMotion"><Circle cx="15" cy="12" r="7.25" stroke="currentColor" strokeWidth="1.5"/><Circle cx="9" cy="12" r="7.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="0.01 2.5"/></CentralIconBase>;
});

export default IconReduceMotion;
